import { apiUrls } from '../../constants/apiUrls';
import { handlePromise } from '../helpers';

export const fetchUserDetails = async () => {
  const apiPayload = {
    method: 'GET',
    url: apiUrls.fetchUserDetailsAPI
  };

  return handlePromise(apiPayload);
};
